// Match the backend's default scope: an unassigned user works at the main office.
export function getAllowedBranches(user, branches = []) {
  if (!user) return [];
  const active = branches.filter(branch => branch.active !== false);
  if (user.user_name === "superadmin" || user.perms?.includes("ALL_BRANCHES")) {
    return active;
  }
  const ids = user.branch_ids?.length
    ? user.branch_ids
    : [user.default_branch_id || 1];
  return active.filter(branch => ids.includes(branch.id));
}
